// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"a953d565","419":"90842216","563":"3952217f","942":"0a3aa49b"}[chunkId] + ".chunk.js";
};